import { quoteQuery } from "@common/api/quoting/quote"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute, Outlet } from "@tanstack/react-router"
import { TaskPane } from "../../-components/task-pane"

export const Route = createFileRoute("/_layout/quotes_/$quoteId/tasks/$taskId")(
  {
    component: TaskPaneRoute,
  },
)

function TaskPaneRoute(): React.ReactElement {
  const { quoteId, taskId } = Route.useParams()
  const { data: quote } = useSuspenseQuery(quoteQuery({ quote_id: quoteId }))
  const task = quote.active_tasks.find((candidate) => candidate.id === taskId)

  if (!task) {
    return (
      <p className="p-8 text-body-medium text-muted-foreground">
        That task is no longer on this quote.
      </p>
    )
  }

  return (
    <>
      <TaskPane key={task.id} quote={quote} task={task} />
      <Outlet />
    </>
  )
}
